import { CSSProperties } from 'react';

export type HowToOpengraphImageProps = {
  time: string | null;
  title: string;
  number: string;
  styles: HowToOpengraphImageStyles;
};

export type HowToOpengraphImageStyles = {
  container: CSSProperties;
};

export function HowToOpengraphImage({
  time,
  title,
  number,
  styles,
}: HowToOpengraphImageProps) {
  return (
    <div
      style={{
        ...styles.container,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        color: 'white',
        paddingLeft: '23px',
        paddingRight: '12px',
        paddingTop: '45px',
      }}
    >
      <p
        style={{
          fontSize: '35px',
          lineHeight: '45.5px',
          marginBottom: '0px',
        }}
      >
        {number}
      </p>
      <h3
        style={{
          fontSize: '20px',
          lineHeight: '115%',
          fontWeight: 700,
          marginBottom: '4px',
        }}
      >
        {title}
      </h3>
      {time && (
        <span
          style={{
            fontSize: '18px',
            lineHeight: '27px',
          }}
        >
          {time}
        </span>
      )}
    </div>
  );
}
